import { useSaucerSelector } from '../context';
export function useAST() {
    var ast = useSaucerSelector(function (state) { return state.ast; });
    return ast;
}
